import { DOCUMENT } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { PrimeNGConfig } from 'primeng/api';
import { MailService } from './service/mail.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title: string;
  viewHeight = window.innerHeight - 150;
  source = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGarage-de-Montplaisir-175600499270754%2F&tabs=timeline%2Cmessages&width=340&height=' + (window.innerHeight - 150) + '&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1320316631741142');

  isMobile = false;
  isSmallDevice = false;

  height = 600;

  // registerForm: FormGroup
  registerForm: FormGroup = new FormGroup({
    nom: new FormControl(''),
    email: new FormControl(''),
    sujet: new FormControl(''),
    message: new FormControl('')
  });
  submitted = false;

  displayContactDialog = false;

  get getWidth(): number {
    if (window.innerWidth < 1180) {
      return window.innerWidth - 100;
    } else {
      return window.innerWidth - 500;
    }
  }

  get pluginFacebookAfficher(): boolean {
    if (this.isMobile) {
      return false;
    }

    return !this.isSmallDevice;
  }

  @ViewChild('iFrameFacebook') iFrameFacebook: ElementRef;
  @ViewChild('iFrameGMaps') iFrameGMaps: ElementRef;

  constructor(
    private sanitizer: DomSanitizer,
    private primengConfig: PrimeNGConfig,
    @Inject(DOCUMENT) private document: Document,
    private formBuilder: FormBuilder,
    private mailService: MailService
  ) {

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // true for mobile device
      this.isMobile = true;
    } else {
      // false for not mobile device
      this.isMobile = false;
    }

    this.primengConfig.ripple = true;
  }

  ngOnInit(): void {
    if (window.innerWidth < 1180) {
      this.isSmallDevice = true;
    }
    window.onresize = () => {
      if (window.innerHeight - 150 !== this.viewHeight) {
        this.viewHeight = window.innerHeight - 150;
        this.source = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGarage-de-Montplaisir-175600499270754%2F&tabs=timeline%2Cmessages&width=340&height=' + (window.innerHeight - 150) + '&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1320316631741142');
      }
      if (window.innerWidth < 1180) {
        this.isSmallDevice = true;
      } else {
        this.isSmallDevice = false;
      }
    };

    this.registerForm = this.formBuilder.group(
      {
        nom: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        sujet: ['', Validators.required],
        message: [
          '',
          [
            Validators.required,
            Validators.minLength(15)
          ]
        ]
      }
    );

  }

  ngAfterViewInit(): void {
    this.loadExternalScript('script-facebook', 'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v12.0&appId=1320316631741142&autoLogAppEvents=1').then(() => { }).catch(() => { });
  }

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.registerForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));

    this.mailService.sendMail(this.registerForm.value.sujet, this.registerForm.value.message, this.registerForm.value.nom, this.registerForm.value.email).subscribe(_ => this.displayContactDialog = false, error => this.displayContactDialog = false);
    this.onReset()
  }

  onReset(): void {
    this.submitted = false;
    this.registerForm.reset();
  }

  showDialogContact(): void {
    this.displayContactDialog = true;
  }

  openFacebook(): void {
    let facebookLink = 'https://www.facebook.com/Garage-de-Montplaisir-175600499270754/';

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // apple user agent
      facebookLink = 'fb://page/?id=175600499270754';
    } else if (/Android/i.test(navigator.userAgent)) {
      facebookLink = 'intent://page/175600499270754?referrer=app_link#Intent;package=com.facebook.katana;scheme=fb;end';
    }

    window.open(facebookLink, '_system');
  }

  upper(): void {
    this.title = this.title.toUpperCase();
  }

  onActivate(event): void {
    window.scroll(0, 0);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.iFrameFacebook) {
      this.iFrameFacebook.nativeElement.setAttribute('style', 'top: ' + (window.pageYOffset + 40) + 'px; position: relative');
    }
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

  EnvoieEmail(): void {
    window.location.href = 'mailto:garagedemontplaisir@gmail.com?subject=Contact%20Garage%20de%20MontPlaisir%20site%20web&body=Entrez%20votre%20message%20ici';
  }




  private loadExternalScript(scriptId: string, scriptUrl: string) {
    return new Promise(resolve => {
      const themeLink = this.document.getElementById(
        scriptId
      ) as HTMLScriptElement;
      if (themeLink) {
        themeLink.src = scriptUrl;
      } else {
        const scriptElement = document.createElement('script');
        scriptElement.src = scriptUrl;
        scriptElement.id = scriptId
        scriptElement.onload = resolve;
        document.body.appendChild(scriptElement);
      }
    });
  }

  private loadExternalStyles(styleId: string, styleUrl: string) {
    return new Promise((resolve, reject) => {

      const themeLink = this.document.getElementById(
        styleId
      ) as HTMLLinkElement;
      if (themeLink) {
        themeLink.href = styleUrl;
      } else {
        const styleElement = document.createElement('link');
        styleElement.href = styleUrl;
        styleElement.rel = 'stylesheet';
        styleElement.id = styleId;

        styleElement.onload = resolve;
        document.head.appendChild(styleElement);
      }

    });
  }

  // loadScript(styleId: string, styleName: string) {
  //   const head = this.document.getElementsByTagName('head')[0];
  //     const style = this.document.createElement('script');
  //     style.id = styleId;
  //     style.src = `${styleName}`;

  //     head.appendChild(style);
  // }

  // loadStyle(styleId:string, styleName: string) {
  //   const head = this.document.getElementsByTagName('head')[0];

  //   let themeLink = this.document.getElementById(
  //     styleId
  //   ) as HTMLLinkElement;
  //   if (themeLink) {
  //     themeLink.href = styleName;
  //   } else {
  //     const style = this.document.createElement('link');
  //     style.id = styleId;
  //     style.rel = 'stylesheet';
  //     style.href = `${styleName}`;

  //     head.appendChild(style);
  //   }
  // }
}
